import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";

import axios from "axios";
import { BASE_URL, security_key } from "../../global";
const ViewsChart = () => {
    const [loading, setLoading] = useState(false);
    const [chartData, setChartData] = useState([]);

    useEffect(() => {
        getAdminAcViewChartData();
    }, []);

    const getAdminAcViewChartData = async () => {
        try {
            setLoading(true);

            const response = await axios.post(`${BASE_URL}API/apicall`, {
                security_key,
                mode: "getAdminAcViewChartData",
            });

            const output = response.data;
            if (output.length > 0) {
                setChartData({
                    dateArr: output.map((row) => row.date),
                    viewArr: output.map((row) => row.view_count),
                    reviewArr: output.map((row) => row.re_view_count),
                });
            } else {
                console.error("Oops! Something went wrong.");
            }
        } catch (error) {
            console.error("Error adding article: " + error.message);
        } finally {
            setLoading(false);
        }
    };

    const apexBarChartOpts = {
        chart: {
            height: 371,
            type: "line",
            toolbar: {
                show: false,
            },
        },
        dataLabels: {
            enabled: false,
        },
        stroke: {
            curve: "smooth",
            width: 3,
        },
        fill: {
            type: ["gradient", "solid"],
            opacity: [0.35, 1],
            gradient: {
                type: "vertical",
                shadeIntensity: 1,
                inverseColors: false,
                opacityFrom: 0.45,
                opacityTo: 0.5,
                stops: [45, 100],
            },
        },
        // labels: ["Jan 01", "Jan 02", "Jan 03", "Jan 04", "Jan 05", "Jan 06", "Jan 07", "Jan 08", "Jan 09", "Jan 10", "Jan 11"],
        labels: chartData["dateArr"],
        legend: {
            show: false,
        },
        colors: ["#686D76", "#3C3D37"],
        yaxis: [
            {
                min: 0, // Set the minimum value for the y-axis
                // max: 100, // Set the maximum value for the y-axis
                title: {
                    // text: 'Series A',
                },
            },
            {
                opposite: true,
                labels: {
                    show: false,
                },
            },
        ],
        tooltip: {
            shared: true,
            intersect: false,
            y: {
                formatter: function (y) {
                    if (typeof y !== "undefined") {
                        return y.toFixed(0) + " views";
                    }
                    return y;
                },
            },
        },
        grid: {
            borderColor: "#f1f3fa",
            padding: {
                bottom: 5,
            },
        },
        responsive: [
            {
                breakpoint: 600,
                options: {
                    yaxis: {
                        show: false,
                    },
                    legend: {
                        show: false,
                    },
                },
            },
        ],
    };

    const apexBarChartData = [
        {
            name: "New",
            type: "area",
            // data: [20, 15, 30, 20, 40, 25, 50, 35, 50, 35, 70],
            data: chartData["viewArr"],
        },
        {
            name: "Returning",
            type: "line",
            // data: [1, 3, 2, 5, 3, 5, 3, 6, 5.3, 8, 7.3],
            data: chartData["reviewArr"],
        },
    ];

    return <Chart options={apexBarChartOpts} series={apexBarChartData} type="area" className="apex-charts" height={371} />;
};

export default ViewsChart;
